import Supercluster from "supercluster";
import type { Feature, Point } from "geojson";
import type { IpPoint } from "./MapModel";

export const POINT_MARKER_SIZE = "44px";

export interface MapClusterProperties {
  cluster?: boolean;
  cluster_id?: number;
  point_count?: number;
  point_count_abbreviated?: number | string;
  pointId?: string;
}

export type MapPointFeature = Feature<Point, MapClusterProperties>;

export const createPointClusterIndex = (points: IpPoint[], isMobile = false, categoryId = 5) => {
  const features: MapPointFeature[] = points.filter((point) =>
    Number.isFinite(point.longitudine) && Number.isFinite(point.latitudine) &&
    Math.abs(point.longitudine) <= 180 && Math.abs(point.latitudine) <= 90
  ).map((point) => ({
    type: "Feature",
    geometry: { type: "Point", coordinates: [point.longitudine, point.latitudine] },
    properties: { pointId: String(point.id) },
  }));
  // Match FiiPregătit: a stable policy per category, independent of point count.
  return new Supercluster({
    radius: categoryId === 5 ? (isMobile ? 120 : 100) : (isMobile ? 72 : 56),
    maxZoom: 14,
    minZoom: 0,
  }).load(features);
};
